import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "importeret",
  "use": "importeret-usage",
  "viewBox": "0 0 38 16.59",
  "content": "<symbol viewBox=\"0 0 38 16.59\" id=\"importeret\"><path d=\"M28.57 16.53a.69.69 0 0 1-.42-.62v-4.85H.71a.69.69 0 0 1-.71-.69V6.22a.69.69 0 0 1 .71-.69h27.44V.69a.65.65 0 0 1 .42-.63.74.74 0 0 1 .77.11l8.44 7.56a.72.72 0 0 1 .22.5.77.77 0 0 1-.22.52l-8.44 7.67a.74.74 0 0 1-.77.11\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/importeret.svg
// module id = 9YST
// module chunks = 1